// src/pages/aboutPage.jsx
import React from "react";
import { useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";
import "./AboutPage.css"; // optional if you want custom styles
import Footer from "../../components/Footer/Footer";
import AboutContent from "../../components/AboutContent/AboutContent";

const AboutPage = () => {

  useEffect(() => {
    document.title = "About Us | Brandly";
  }, []);
  
  return (
    <div className="about-wrapper">
      <Navbar />
      <AboutContent/>
      <Footer/>
    </div>
  );
};

export default AboutPage;
